export enum RsjInstructionPaymentOpinion {
  Positive = 'Favorable',
  Neutral = 'Réservé',
  Negative = 'Défavorable',
}
